<template>
  <div class="d-flex my-5 justify-space-between">
    <div class="w-16 pr-5">
      <v-text-field
        label="Product ID"
        v-model="productId"
        @change="$emit('update:productId', $event)"
        dense
        solo
        hide-details
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="w-16 pr-5">
      <v-autocomplete
        :items="suppliers"
        label="Supplier"
        v-model="supplierId"
        @change="$emit('update:supplierId', $event)"
        dense
        solo
        hide-details
        append-icon="apartment"
        item-text="name"
        item-value="id"
      ></v-autocomplete>
    </div>
    <div class="w-16 pr-5">
      <v-autocomplete
        :items="brands"
        v-model="brandId"
        @change="$emit('update:brandId', $event)"
        label="Brand"
        dense
        hide-details
        append-icon="tab"
        item-text="name"
        item-value="id"
        solo
      ></v-autocomplete>
    </div>
    <div class="w-16 pr-5">
      <v-autocomplete
        :items="statuses"
        v-model="statusId"
        @change="$emit('update:statusId', $event)"
        label="Status"
        dense
        hide-details
        solo
        item-text="name"
        item-value="id"
        append-icon="edit_attributes"
      ></v-autocomplete>
    </div>
    <div class="w-16 pr-5">
      <v-select
        :items="actions"
        label="Batch Action"
        append-icon="more_vert"
        class="action_button"
        :disabled="!action"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        hide-details
        solo
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item class="pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    Delete
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-select>
    </div>
    <div class="w-16 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    productId: {
      type: String,
      default: null
    },
    brandId: {
      type: String,
      default: null
    },
    supplierId: {
      type: String,
      default: null
    },
    statusId: {
      type: String,
      default: null
    },
    action: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    statuses() {
      let statuses = this.$store.state.productstatuses.statuses;
      statuses.unshift({
        name: "All",
        id: null
      });
      return statuses;
    },
    brands() {
      let brands = this.$store.state.brands.brands;
      brands.unshift({
        name: "All",
        id: null
      });
      return brands;
    },
    suppliers() {
      let suppliers = this.$store.state.suppliers.suppliers;
      suppliers.unshift({
        name: "All",
        id: null
      });
      return suppliers;
    }
  },
  async mounted() {
    await this.$store.dispatch("productstatuses/LOAD_PRODUCT_STATUSES");
    this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("brands/LOAD_BRANDS", {
      from: 0,
      to: 0
    });
  },
  data() {
    return {
      actions: [
        {
          value: 1,
          text: "Update Status"
        },
        {
          value: 2,
          text: "Update Brand"
        },
        {
          value: 3,
          text: "Update Supplier"
        }
      ]
    };
  }
};
</script>
